module.exports = __webpack_public_path__ + "img/738597b72732ba904ae94848afae0c35.svg";